import React, { useState, useEffect } from 'react';
import { X, Mail, ArrowRight, Fish, Gift } from 'lucide-react';
import axiosInstance from '../api/axiosInstance';
import toast from 'react-hot-toast';
import './NewsletterPopup.css';

const NewsletterPopup = () => {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [subscribing, setSubscribing] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    // Don't show if already subscribed or dismissed recently
    const dismissed = localStorage.getItem('aurora_newsletter_dismissed');
    const subscribed = localStorage.getItem('aurora_newsletter_subscribed');
    if (subscribed) return;
    if (dismissed) {
      const dismissedAt = new Date(dismissed);
      const daysSince = (Date.now() - dismissedAt.getTime()) / (1000 * 60 * 60 * 24);
      if (daysSince < 7) return; // Don't show again for 7 days after dismiss
    }
    // Show after 8 seconds
    const timer = setTimeout(() => setVisible(true), 8000);
    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('aurora_newsletter_dismissed', new Date().toISOString());
    setVisible(false);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setSubscribing(true);
    try {
      const res = await axiosInstance.post('/newsletter/subscribe', { email, firstName });
      if (res.data.success) {
        setSuccess(true);
        localStorage.setItem('aurora_newsletter_subscribed', 'true');
        setTimeout(() => setVisible(false), 3000);
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to subscribe');
    } finally {
      setSubscribing(false);
    }
  };

  if (!visible) return null;

  return (
    <div className="nl-popup-overlay" onClick={handleDismiss}>
      <div className="nl-popup" onClick={e => e.stopPropagation()}>
        <button className="nl-popup-close" onClick={handleDismiss}><X size={18} /></button>

        {success ? (
          <div className="nl-popup-success">
            <div className="nl-popup-success-icon">🎉</div>
            <h3>You're in!</h3>
            <p>Welcome to Aurora Seafood! Head to your account and get your 10% loyalty discount card — it activates immediately on all orders.</p>
          </div>
        ) : (
          <>
            <div className="nl-popup-top">
              <div className="nl-popup-badge"><Gift size={14} /> Loyalty card holders save 10%</div>
              <div className="nl-popup-fish"><Fish size={40} color="#29ABE2" strokeWidth={1} /></div>
              <h2 className="nl-popup-title">Unlock Your <span>10% Discount</span> Card</h2>
              <p className="nl-popup-desc">
                Subscribe to stay updated, then check your Aurora account to purchase your 10% loyalty discount card — active immediately on all orders.
              </p>
            </div>

            <form onSubmit={handleSubscribe} className="nl-popup-form">
              <input
                type="text"
                placeholder="First name (optional)"
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
                className="nl-popup-input"
              />
              <input
                type="email"
                placeholder="Your email address *"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="nl-popup-input"
                required
              />
              <button type="submit" className="nl-popup-btn" disabled={subscribing}>
                {subscribing ? 'Subscribing...' : <><Mail size={15} /> Subscribe Now</>}
              </button>
            </form>

            <p className="nl-popup-fine">
              No spam, ever. Unsubscribe anytime. By subscribing you agree to our{' '}
              <a href="/privacy-policy">Privacy Policy</a>.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default NewsletterPopup;